module.exports = __webpack_public_path__ + "static/img/4.9cbcbcb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/1/eng/4.png
// module id = uF49
// module chunks = 0